import MultiSelect from "../../../../formFields/DropDown/Multiselect";
import { useDropDownData } from "./Hooks/useDropDownData";


const DropDownSearch = ({ ApiMethod, sourceId, isMulti, accessor, Header, probName, className, optionList, selectFirst }) => {

    const { options, sOptions, handleSOption } = useDropDownData(ApiMethod, optionList, sourceId, (accessor || probName), isMulti, selectFirst)

    return <MultiSelect
        isClearable
        className={className}
        containerClassName={"col-lg-4 col-md-6 col-sm-12"}
        options={options}
        isMulti={isMulti}
        name={Header}
        value={sOptions}
        setValue={handleSOption} />

};

export default DropDownSearch;
